/**
 * Splits a flat box list into one list per sheet, in page order.
 *
 * A template can span pages - a valve is 01, 02 and Application Specific. DS_Sheet carries that
 * on every box, while DS_Line keeps its existing zone meanings WITHIN each sheet. DsSheetPage
 * renders exactly one page from a flat list and knows nothing about sheets, so the split happens
 * here and each group is handed to its own page. That keeps every zone rule, width calculation
 * and static-section constant in DsSheetPage untouched.
 *
 * A box with no sheet belongs to page 1: every template written before the column existed is a
 * single page, and that page is page 1.
 *
 * A box on sheet 0 is shared - the header and center panel are one copy per template - so it is
 * added to every page rather than becoming a page of its own.
 *
 * Always returns at least one group, so an empty datasheet still prints a page rather than a
 * zero-page PDF, which some viewers refuse to open at all.
 */
export const SHARED_SHEET = 0;

export default function groupBoxesBySheet(boxes = []) {
  const bySheet = new Map();
  const shared = [];
  for (const box of boxes) {
    const sheet = box.sheet ?? 1;
    if (sheet === SHARED_SHEET) { shared.push(box); continue; }
    if (!bySheet.has(sheet)) bySheet.set(sheet, []);
    bySheet.get(sheet).push(box);
  }
  if (bySheet.size === 0) return [{ sheet: 1, boxes: shared }];
  return [...bySheet.entries()]
    .sort((a, b) => a[0] - b[0])
    .map(([sheet, group]) => ({ sheet, boxes: [...shared, ...group] }));
}
